module.exports = __webpack_public_path__ + "img/雄县塑料制品.76ecb7f7.jpg";